import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateCurrentItemLikes } from "appRedux/slices/wishListSlice"
import { useLazyGetLikesQuery, wishItemApi } from "appRedux/slices/wishItemApiSlice"

export default function useGetLikes(id: number, show: boolean) {
  const currentItemLikes = useAppSelector(state => state.wishList.currentItemLikes)
  const cachedCurrentItemLikes = useAppSelector((state) => id ? wishItemApi.endpoints.getLikes.select(id)(state) : null)

  const [triggerGetLikes, getCLikesResult] = useLazyGetLikesQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!show) return
    if (cachedCurrentItemLikes?.data) {
      dispatch(updateCurrentItemLikes(cachedCurrentItemLikes?.data || []))
      return
    }
    fetchLikes()
  }, [id, show])

  function fetchLikes() {
    triggerGetLikes(id)
  }

  return {
    users: currentItemLikes?.users || cachedCurrentItemLikes?.data?.users || getCLikesResult?.data?.users || [],
    isFetching: getCLikesResult.isFetching,
    isError: getCLikesResult.isError
  }
}
